import React, { useEffect,  useRef } from "react";
import { Routes, Route, useNavigate } from "react-router-dom"; 
import './assets/css/index.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// Utils 
import { setNavigator } from "./utils/navigation"; 
// Layouts
import ProtectedRoute from "./components/Admin/common/ProtectedRoute";
import Layout from './components/common/Layout'
import DashboardLayout from "./components/Admin/common/LayoutDashboard";
import ToastProvider from "./components/common/ToastProvider";

// Public Pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import CancellationRefunds from "./pages/CancellationRefunds";
import MerchantDetail from "./pages/MerchantListing/MerchantDetail";
import MerchantCategories from  "./pages/MerchantSearch";

// Auth
import AuthRoute from "./routes/AuthRoute";
import SubscriptionRoute from "./routes/SubscriptionRoute";
import RoleRoute from "./routes/RoleRoute";
import Login from './pages/auth/login';
import Register from './pages/auth/register';
import Profile from './pages/auth/profile';
import ForgotPassword from './pages/auth/ForgotPassword';

// Merchant Auth
import MerchantRegister from './pages/merchant/auth/register';
import MerchantLogin from './pages/merchant/auth/login';
import MerchantInquiry from './pages/merchant/auth/MerchantInquiry';
import MerchantInquiryStatus from './pages/merchant/auth/InquiryStatus';
import BuySubscription from "./pages/merchant/auth/buySubscription";

// Merchant Dashboard
import MerchantOverview from "./pages/merchant/dashboard/Overview";
import MerchantCatalogue from "./pages/merchant/dashboard/Catalogue";
import MerchantQuickInfo from "./pages/merchant/dashboard/QuickInfo";
import MerchantVisitingCard from "./pages/merchant/dashboard/VisitingCard";
import MerchantProfile from "./pages/merchant/dashboard/Profile";
import MerchantSubscription from "./pages/merchant/dashboard/Subscription";
import SupportHelp from "./pages/merchant/dashboard/Support";
import Privacy from "./pages/merchant/dashboard/privacy";
import Terms from "./pages/merchant/dashboard/terms"; 
import About from "./pages/merchant/dashboard/about";
import CmsPage from "./components/common/CmsPage";
import BannerAdvertisement from "./pages/merchant/dashboard/BannerRequest";
import ProfileSponsorship from "./pages/merchant/dashboard/sponsor/ProfileSponsorship";
import BookletBooking from "./pages/merchant/dashboard/Booklet/Booklet";
import CamOrders from "./pages/merchant/dashboard/Booklet/CamOrders";
import CardAdvertising from "./pages/merchant/dashboard/CardAdvertising/AdvertisingSlots";
import UserVisitingCard from "./pages/merchant/dashboard/userDashboard/UserVisitingCard";
import DashboardIndex from "./components/Admin/common/DashboardIndex";
import MyOrders from "./pages/merchant/dashboard/MyOrders/PaymentHistory";
import PaymentDetailsModal from "./pages/merchant/dashboard/MyOrders/PaymentDetailsModal";
import MyBookings from "./pages/merchant/dashboard/Bookings/MyBookings"
import BookingDetails from "./pages/merchant/dashboard/Bookings/BookingDetails"
// user separate pages
import UserProfile from "./pages/merchant/dashboard/userDashboard/UserProfile";
import Notifications from "./pages/merchant/dashboard/notifications/Notifications"
import { useDispatch } from "react-redux";
import { restoreSession } from "./features/merchant/merchantThunks";

const NavigatorProvider = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);
  return null;
};

function App() {
  const dispatch = useDispatch(); 
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      dispatch(restoreSession());
      initialized.current = true;
    }
  }, [dispatch]);

  return (
    <>
      <NavigatorProvider />
      <ToastProvider />
      <Routes>
        {/* Public Layout */}
          {/* <Route path="/" element={<Home />} />     */}
        <Route element={<Layout />}>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />}/>
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/cancellation-and-refunds" element={<CancellationRefunds />}/>
        <Route path="/merchant-search" element={<MerchantCategories />} />
        <Route path="/merchant-detail/:id" element={<MerchantDetail />} />  
        
          {/* User Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/forget-password" element={<ForgotPassword />} />

          {/* Merchant Auth */}
          <Route path="/merchant-register" element={<MerchantRegister />} />
          <Route path="/merchant-login" element={<MerchantLogin />} />
          <Route path="/merchant-inquiry" element={<MerchantInquiry />} />
          <Route path="/inquiry-status" element={<MerchantInquiryStatus />} />
          <Route path="/buy-subscription" element={<BuySubscription />} />

           
        </Route>

        {/* Dashboard */}
       <Route element={<AuthRoute />}>
         <Route element={<SubscriptionRoute />}>
        <Route path="/dashboard" element={<DashboardLayout />}>
        <Route path="payment-details/:orderId" element={<PaymentDetailsModal />} />
     
           {/* SINGLE INDEX ROUTE */}
        <Route index element={<DashboardIndex />} />
           {/* merchant special pages ends */}
          {/* <Route path="merchant-visitingcard" element={<MerchantVisitingCard />} /> */}
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="my-bookings" element={<MyBookings />} />
          <Route path="cam-orders" element={<CamOrders />} />
         <Route path="booking-details/:id" element={<BookingDetails />} />
          <Route path="merchant-profile" element={<MerchantProfile />} />
          <Route path="merchant-subscription" element={<MerchantSubscription />} />
          <Route path="help-support" element={<SupportHelp />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="terms-and-conditions" element={<Terms />} />  
          <Route path="about-us" element={<About />} />  
          <Route path="notifications" element={<Notifications />}/>
          {/* <Route path="cms/:pageSlug" element={<CmsPage />} /> */}
          <Route path="banner-advertisement" element={<BannerAdvertisement />} />
          <Route path="card-advertising" element={<CardAdvertising />} />
        {/* user routes */}
          <Route path="user-profile" element={<UserProfile />} />
          <Route path="user-visitingcard" element={<UserVisitingCard />} />
           <Route path="merchant-subscription" element={<MerchantSubscription />} />

           {/* merchant special pages */}
          <Route element={<RoleRoute allowedRoles={["merchant"]} />}>
          <Route path="merchant-visitingcard" element={<MerchantVisitingCard />} />
          <Route path="merchant-overview" element={<MerchantOverview />} />
          <Route path="merchant-catalogue" element={<MerchantCatalogue />} />
          <Route path="merchant-quickinfo" element={<MerchantQuickInfo />} />
          <Route path="sponsorship-profile" element={<ProfileSponsorship />} />
          <Route path="booklet-magazine" element={<BookletBooking />} />  
          </Route>
        </Route>
        </Route>
        </Route>
      </Routes>

    </>
  );
}

export default App;
